import { Check, Clock, CreditCard, ShieldCheck } from "lucide-react";

export function FinalCTA() {
  return (
    <section className="mx-auto max-w-6xl px-6 py-12 lg:px-12">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary to-primary-dark p-8 text-primary-foreground shadow-xl sm:p-12">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-wider backdrop-blur-sm ring-1 ring-white/25">
            <Clock className="h-3.5 w-3.5" aria-hidden />
            Bientôt disponible
          </span>
          <h2 className="mt-4 text-3xl font-bold sm:text-4xl">
            Allez plus loin avec un audit personnalisé
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base opacity-95">
            Nos experts décortiqueront votre projet et identifieront les optimisations qui vous feront vraiment économiser. Cette offre arrive très prochainement.
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" aria-hidden>
          {/* Audit */}
          <div className="relative rounded-2xl bg-background p-6 text-foreground shadow-lg opacity-80">
            <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-warning/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-warning">
              <Clock className="h-3 w-3" aria-hidden />
              Coming soon
            </span>
            <div className="flex items-baseline justify-between">
              <h3 className="text-lg font-bold">Audit express</h3>
              <span className="text-3xl font-extrabold text-primary">49€</span>
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <Item>Analyse complète par un expert LMNP</Item>
              <Item>Rapport personnalisé sous 48h</Item>
              <Item>30 min d'appel pour vos questions</Item>
              <Item>Optimisations fiscales sur-mesure</Item>
            </ul>
            <button
              type="button"
              disabled
              className="mt-5 w-full cursor-not-allowed rounded-xl bg-muted px-4 py-3 text-sm font-semibold text-muted-foreground"
            >
              Bientôt disponible
            </button>
          </div>

          {/* Formation */}
          <div className="relative rounded-2xl bg-background p-6 text-foreground shadow-lg opacity-80">
            <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-warning/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-warning">
              <Clock className="h-3 w-3" aria-hidden />
              Coming soon
            </span>
            <div className="flex items-baseline justify-between">
              <h3 className="text-lg font-bold">Formation LMNP</h3>
              <span className="text-3xl font-extrabold text-primary">199€</span>
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <Item>12 modules vidéo (3h de contenu)</Item>
              <Item>Templates Excel de suivi</Item>
              <Item>Checklist des charges déductibles</Item>
              <Item>Mises à jour fiscales annuelles</Item>
            </ul>
            <button
              type="button"
              disabled
              className="mt-5 w-full cursor-not-allowed rounded-xl border-2 border-muted bg-background px-4 py-3 text-sm font-semibold text-muted-foreground"
            >
              Bientôt disponible
            </button>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center text-xs opacity-90">
          <span className="inline-flex items-center gap-1"><CreditCard className="h-3.5 w-3.5" aria-hidden />Paiement sécurisé Stripe</span>
          <span aria-hidden>·</span>
          <span>Facture française</span>
          <span aria-hidden>·</span>
          <span className="inline-flex items-center gap-1"><ShieldCheck className="h-3.5 w-3.5" aria-hidden />Satisfait ou remboursé 14j</span>
        </div>
      </div>
    </section>
  );
}

function Item({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex items-start gap-2">
      <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-success/15 text-success"><Check className="h-2.5 w-2.5" aria-hidden /></span>
      <span className="text-muted-foreground">{children}</span>
    </li>
  );
}
